var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.008,
    height: 13.414,
    viewBox: "0 0 12.008 13.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3e3e3e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.165)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.687)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M114.274,0a3.483,3.483,0,1,0,3.483,3.483A3.492,3.492,0,0,0,114.274,0Z",
    transform: "translate(-110.791)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.165 7.215)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.147,250.375a3.248,3.248,0,0,0-.35-.639,4.329,4.329,0,0,0-3-1.886.641.641,0,0,0-.441.106,3.713,3.713,0,0,1-4.38,0,.571.571,0,0,0-.441-.106,4.3,4.3,0,0,0-3,1.886,3.744,3.744,0,0,0-.35.639.323.323,0,0,0,.015.289,6.071,6.071,0,0,0,.411.608,5.78,5.78,0,0,0,.7.791,9.123,9.123,0,0,0,.7.608,6.936,6.936,0,0,0,8.274,0,6.687,6.687,0,0,0,.7-.608,7.025,7.025,0,0,0,.7-.791,5.333,5.333,0,0,0,.411-.608A.26.26,0,0,0,36.147,250.375Z",
    transform: "translate(-24.165 -247.841)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d91734d392d6265134dcf37127d310d5.svg";
export { ForwardRef as ReactComponent };